import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { Button } from "@mui/material";
import Details from './ViewPageTabs/Details';
import FileUploader from './ViewPageTabs/FileUpload';
import SkillandHobbies from './ViewPageTabs/SkillandHobbies';
import EmergencyContact from './ViewPageTabs/EmergencyContact';
import Appraisals from './ViewPageTabs/Appraisals ';
import Ratings from './ViewPageTabs/Ratings';
import Selfies from './ViewPageTabs/Selfies';
import Notes from './ViewPageTabs/Notes';
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs({ setTabs, ID }) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>

            <Box sx={{ width: '100%', mt: 5 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ ml: 2 }}>
                        <Tab label="Details" {...a11yProps(0)} />
                        <Tab label="Documents" {...a11yProps(1)} />
                        <Tab label="Skills and Hobbies" {...a11yProps(2)} />
                        <Tab label="Emergency Contacts" {...a11yProps(3)} />
                        <Tab label="Appraisals" {...a11yProps(4)} />
                        <Tab label="Ratings" {...a11yProps(5)} />
                        <Tab label="Selfi" {...a11yProps(6)} />
                        <Tab label="Notes" {...a11yProps(7)} />


                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <Details ID={ID} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <FileUploader />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <SkillandHobbies />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <EmergencyContact />
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <Appraisals />
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <Ratings />
                </TabPanel>
                <TabPanel value={value} index={6}>
                    <Selfies />
                </TabPanel>
                <TabPanel value={value} index={7}>
                    <Notes />
                </TabPanel>

            </Box>
            <Divider />

            <div style={{ width: '95%', display: 'flex', justifyContent: 'end', marginTop: 5 }}>
                <Button variant="contained" onClick={() => setTabs(false)} style={{ width: 'fit-content', mr: 7 }}>
                    Cancel
                </Button>

            </div>
        </>
    );
}
